import { pullAt } from "lodash/fp";
import _ from "lodash";
import i18n from "i18next";

import {
  LOGIN_FAILURE,
  LOGIN_SUCCESS,
  SET_ERROR,
  SET_IS_AUTHENTICATED,
  SET_IS_FIREBASE_AUTHENTICATED,
  SET_ROUTER_STATE,
  SET_SCREEN_SIZE,
  SET_SESSION_PREFERENCES,
  SET_USER,
  SET_USER_METADATA,
  SET_USER_METADATA_FETCHED,
  START_ASYNC_ACTION,
  STOP_ASYNC_ACTION
} from "../actions/types";

const initialState = {
  errorCode: null,
  errorStack: null,
  errorCorrelationId: null,
  errorTimestamp: null,
  isFirebaseAuthenticated: false,
  isAuthenticated: false,
  isLaptop: false,
  isUserMetadataFetched: false,
  pendingActions: [],
  routerParams: {},
  routerState: {},
  sessionPreferences: {},
  user: {},
  userMetadata: {}
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case LOGIN_SUCCESS:
      return { ...state, isAuthenticated: payload.isAuthenticated, user: payload.user };
    case LOGIN_FAILURE:
      return { ...state, ...payload };
    case SET_ERROR: {
      const errorCode = _.toString(_.get(payload, "response.status", "global"));
      const errorStack = payload ? payload.stack : null;
      const errorCorrelationId = _.get(payload, "response.headers.x-correlation-id", null);
      const now = new Date();
      const errorTimestamp = payload ? now.toString() : null;
      return { ...state, errorCode: payload ? i18n.t(`error.${errorCode}`) : null, errorStack, errorCorrelationId, errorTimestamp };
    }
    case SET_IS_FIREBASE_AUTHENTICATED:
      return { ...state, isFirebaseAuthenticated: payload };
    case SET_IS_AUTHENTICATED:
      return { ...state, isAuthenticated: payload };
    case SET_ROUTER_STATE:
      return { ...state, routerState: payload.to(), routerParams: payload.params() };
    case SET_SCREEN_SIZE:
      return { ...state, isLaptop: payload.isLaptop, isMobile: payload.isMobile };
    case SET_SESSION_PREFERENCES:
      return { ...state, sessionPreferences: { ...state.sessionPreferences, ...payload } };
    case SET_USER:
      return { ...state, user: payload };
    case SET_USER_METADATA_FETCHED:
      return { ...state, isUserMetadataFetched: true };
    case SET_USER_METADATA:
      return { ...state, userMetadata: payload };
    case START_ASYNC_ACTION:
      return { ...state, pendingActions: [...state.pendingActions, payload] };
    case STOP_ASYNC_ACTION:
      const pendingActions = pullAt(_.indexOf(state.pendingActions, payload), state.pendingActions);
      return { ...state, pendingActions };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/appReducer.js